import { render, staticRenderFns } from "./AcoesDocumentosCompraDireta.vue?vue&type=template&id=a1c4c76a&scoped=true"
import script from "./AcoesDocumentosCompraDireta.vue?vue&type=script&lang=js"
export * from "./AcoesDocumentosCompraDireta.vue?vue&type=script&lang=js"
import style0 from "./AcoesDocumentosCompraDireta.vue?vue&type=style&index=0&id=a1c4c76a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c4c76a",
  null
  
)

export default component.exports